<template>
  <div class="welcome-img">
    <img src="assets/img/welcom-title.png" class="img-responsive">
  </div>
</template>

<script>
export default {
  name: "Logo"
};
</script>

<style scoped>
</style>
